// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30PQF","content":"styles_content__2Ttdk"};